
export default (successTypes, resultKey) => {
  const INITIAL_STATE = {};

  return (state = INITIAL_STATE, action) => {
    if(successTypes.indexOf(action.type) >= 0) {
      return {
        ...state,
        [action.page]: [...action.result[resultKey]]
      };
    }

    return state;
  };
};



/** WEBPACK FOOTER **
 ** ./src/members/state/__shared__/reducersMakers/byPageMaker.js
 **/